import { toast } from "sonner";
import { AxiosError } from "axios";

export function toastFromError(err: unknown, fallback = "Something went wrong") {
  if (err instanceof AxiosError && err.response?.data?.error?.message) {
    toast.error(err.response.data.error.message);
    return;
  }
  toast.error(fallback);
}

export function getErrorCode(err: unknown): string | null {
  if (err instanceof AxiosError && err.response?.data?.error?.code) {
    return err.response.data.error.code as string;
  }
  return null;
}

export function getFieldErrors(err: unknown): Record<string, string[]> | null {
  if (err instanceof AxiosError) {
    const details = err.response?.data?.error?.details;
    if (details?.fields) return details.fields as Record<string, string[]>;
  }
  return null;
}
